import React from "react";
import { Feather as Icon } from 'react-web-vector-icons';

export const DetailActionButton = ({ name, icon, onPress }) => {
  return (
    <div id={name} className="detailActionButton" onClick={onPress}>
      <Icon name={icon} color='var(--onSurfaceStrong)' size={22} />
    </div>
  )
}